// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.48063 2.5H1V21H23V5H11.4806L9.48063 2.5ZM16 14H13V17H11V14H8V12H11V9H13V12H16V14Z"}}]};

const FolderAdd1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-add-1-filled',
    ref,
    icon: element,
  },
));

FolderAdd1FilledIcon.displayName = 'FolderAdd1FilledIcon';

export default FolderAdd1FilledIcon;
